export { type WordTwData, wordTwDataTable } from "#word-tw-data-table";
